export default __webpack_public_path__ + "static/media/element_spec_47.53ef016c.webp";